import { ArchiveCheckIcon } from './ArchiveCheckIcon';

/**
 * author: Colton Wiscombe
 * id 03F9B9A5-04B8-4A24-AE38-87BE165BBE35
 * name archive-check
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/archive-check.svg
 * tags
 */
export const BoxSuccessIcon = ArchiveCheckIcon;
export default BoxSuccessIcon